export const contentPath = 'content'
